import {athubAxios} from '../../util'
import {RestResource} from '../rest'
import {AUTOKEY_SERVER} from '../server'

const AutokeyApi = {

    gen(app) {
        let url = `${AUTOKEY_SERVER}/key/gen/${app}/1`;
        let promise = new Promise((resolve, reject) => {
            athubAxios.get(url).then(responseBody => {
                if (responseBody.status == 200 && responseBody.data.code == 'OK') {
                    resolve(responseBody.data.keys[0]);
                } else {
                    reject(responseBody.data.msg);
                }
            })
        });
        return promise;
    },


}

export default AutokeyApi;